// cn.ts
// Helper classnames pour combiner des classes Tailwind — constitution §III.
// Utilise clsx + tailwind-merge pour éviter les conflits de classes Tailwind.

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
